module.exports = __webpack_public_path__ + "static/img/shoppingCartDefault.2d9bb267.png";